import React from 'react';
import { TrialBenefitsDialog } from '../../experiments/TrialConversion/TrialBenefitsDialog';

export const TrialBenefitsView: React.FC = () => {

    return (
        <>
            <TrialBenefitsDialog />
        </>
    );
};
